//=====================================================
//　G003：予約日付選択
//=====================================================
import { createContext, useEffect, useState, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ContentsBox } from "../../common/ContentsBox";
import { ContentsTitle } from "../../common/ContentsTitle";
import { G003CalendarNotes } from "./G003CalendarNotes";
import { G003CalendarMonthly } from "./G003CalendarMonthly";
import { G003CalendarWeekly } from "./G003CalendarWeekly";
import { BtnReturn } from "../../common/BtnReturn";
import { ReservationFlow, ProcessName } from "../../common/ReservationFlow";
import { ReservationInfo } from "../../common/ReservationInfo";
import { CtxClinicInfo, CtxClinicSystemInfo, CtxNewReservation } from "../../utils/Contexts";
import { useAuth } from "../../utils/UseAuth";
import { ReservationType } from "../../utils/ConstCommon";

interface IFCtxCalendarInfo {
    cDate: Date,
    setCDate: React.Dispatch<React.SetStateAction<Date>>,
    cMonth: Date,
    setCMonth: React.Dispatch<React.SetStateAction<Date>>,
    moveflg:boolean,
    setMoveflg: React.Dispatch<React.SetStateAction<boolean>>,
}

export interface IFG003Param {
    mode: string
}

//カレンダーモード（月/週）
export const G003MODE_MONTHLY = "monthly";
export const G003MODE_WEEKLY = "weekly";

//コンテキスト宣言
export const CtxG003 = createContext<IFCtxCalendarInfo>({cDate: new Date(), setCDate: function(){}, cMonth: new Date(), setCMonth: function(){}, moveflg:false, setMoveflg: function(){}});

export function G003(){

    const params = useParams<IFG003Param>();
    const history = useHistory();
    const cci = useContext(CtxClinicInfo);
    const cnr = useContext(CtxNewReservation);
    const ccsi = useContext(CtxClinicSystemInfo);
    const ua = useAuth();

    // ブラウザバックで表示させない処理
    useEffect(function(){
        //タイトル追加処理
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - 予約日付選択";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - 予約日付選択";
        }

        // マウントフラグ
        let isMounted = true;
        
        // アンマウント時はstate(history)を更新しないようにする
        if(isMounted){
            // 完了データの場合、マイページ、トップ画面へ遷移
            if(cnr.data.done){
                if(ua.isLoggedIn()){
                    history.push('/mypage');
                } else {
                    history.push('/');
                }
            }
            setMoveflg(false);
        }

        // cleanup関数(Unmount時の処理)
        return () => {
            // マウントオフ
            isMounted = false;
        }
        // アンマウント時にのみ一回だけ実行したいため第2引数指定なし。
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //現在の月
    const [cDate, setCDate] = useState<Date>(new Date());
    //月カレンダーで表示していた月
    const [cMonth, setCMonth] = useState<Date>(new Date());
    //カレンダー表示月移動時のフラグ
    const [moveflg, setMoveflg] = useState(false);
    
    //モード切り替えのクラス
    let modeClass = "calendar-monthly";
    if (params.mode === G003MODE_WEEKLY){
        modeClass = "calendar-weekly";
    }

    //ReservationInfo表示フラグ
    //(再診かつ治療種別表示フラグOFFかつ担当医表示フラグOFFかつ予約日時未選択)の場合表示しない。それ以外の場合表示する。
    const isDisplayReservationInfo = !((cnr.type === ReservationType.Return || cnr.type === ReservationType.Change)
        && !ccsi.data.display.medicalType && !ccsi.data.display.doctor && !cnr.data.date && !cnr.data.beforeDate);

    return (
        <>
            <ReservationFlow currentProcess={ProcessName.Date}/>
            {isDisplayReservationInfo &&
                <ContentsBox>
                    <ReservationInfo />
                </ContentsBox>
            }
            <ContentsBox>
                <CtxG003.Provider value={{cDate: cDate, setCDate: setCDate, cMonth: cMonth, setCMonth: setCMonth, moveflg:moveflg, setMoveflg:setMoveflg}}>
                    <ContentsTitle title="ご希望の予約日時を選択してください" />
                    <div className={modeClass}>
                        <G003CalendarNotes />
                        {params.mode === G003MODE_MONTHLY ? 
                            <G003CalendarMonthly />
                            :
                            <G003CalendarWeekly />
                        }
                    </div>
                </CtxG003.Provider>
            </ContentsBox>
            {params.mode === G003MODE_MONTHLY ?
                <BtnReturn />
                :
                <BtnReturn onClick={function(){setCDate(cMonth);history.goBack()}} />
            }
        </>
    );

}